import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TextField,
  makeStyles,
} from "@material-ui/core";

import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

import { useAlert } from "react-alert";
import { useParams } from "react-router-dom";

import EditRoundedIcon from "@material-ui/icons/EditRounded";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddIcon from "@material-ui/icons/Add";

import {
  AuctionType,
  AuctionUpdateSend,
  GetAuctionByID,
  GetAuctionSetByID,
} from "../../../adminModel/auctions";

import UploadImage from "./uploadImage";
import UpdateAuctionDialog from "./UpdateAuctionDialog";
import AuctionSetupCreate from "./auctionSetupCreate";


// =====================================================
// STYLES
// =====================================================

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  card: {
    border: "1px solid #e5e7eb",
    borderRadius: 10,
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
    backgroundColor: "#fff",
    overflow: "hidden",
  },

  cardHeader: {
    padding: "20px 24px",

    "& .MuiCardHeader-title": {
      fontSize: 17,
      fontWeight: 600,
      color: "#202124",
    },

    "& .MuiCardHeader-subheader": {
      fontSize: 13,
      color: "#6b7280",
      marginTop: 4,
    },
  },

  cardContent: {
    padding: "28px 24px",

    [theme.breakpoints.down("sm")]: {
      padding: "22px 18px",
    },
  },

  section: {
    marginBottom: 34,
  },

  section: {
    marginBottom: 0,
  },

  sectionTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: "#374151",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: 6,
  },

  sectionDescription: {
    fontSize: 13,
    color: "#6b7280",
    marginBottom: 22,
  },

  field: {
    width: "100%",

    "& .MuiOutlinedInput-root": {
      borderRadius: 7,
      backgroundColor: "#fff",
      minHeight: 46,
    },

    "& .MuiInputLabel-root": {
      fontSize: 14,
    },

    "& .MuiInputBase-input": {
      fontSize: 14,
    },
  },

  fieldGroup: {
    marginBottom: 4,
  },

  divider: {
    margin: "30px 0",
  },

  actionBar: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingTop: 24,
    marginTop: 10,
    borderTop: "1px solid #eeeeee",
  },

  updateButton: {
    minWidth: 150,
    height: 42,
    borderRadius: 7,
    textTransform: "none",
    fontWeight: 600,
    boxShadow: "none",

    "&:hover": {
      boxShadow: "none",
    },
  },

  mediaWrapper: {
    padding: 4,
  },

  setsToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 14,
    },
  },

  setsCount: {
    fontSize: 13,
    color: "#6b7280",
  },

  addButton: {
    height: 40,
    borderRadius: 7,
    textTransform: "none",
    fontWeight: 600,
    boxShadow: "none",

    "&:hover": {
      boxShadow: "none",
    },
  },

  tableContainer: {
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    overflow: "hidden",
  },

  table: {
    minWidth: 700,
  },

  tableHead: {
    backgroundColor: "#f8f9fa",
  },

  tableHeadCell: {
    padding: "13px 16px",
    fontSize: 12,
    fontWeight: 700,
    color: "#4b5563",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    borderBottom: "1px solid #e5e7eb",
  },

  tableCell: {
    padding: "14px 16px",
    fontSize: 13,
    color: "#374151",
    borderBottom: "1px solid #f0f0f0",
  },

  setName: {
    fontWeight: 600,
    color: "#202124",
  },

  dateText: {
    lineHeight: 1.6,
  },

  timeText: {
    fontSize: 12,
    color: "#6b7280",
  },

  actionButton: {
    marginLeft: 6,
    borderRadius: 6,
    textTransform: "none",
  },

  emptyState: {
    padding: 45,
    textAlign: "center",
    color: "#9ca3af",
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));


// =====================================================
// COMPONENT
// =====================================================

export default function View() {
  const classes = useStyles();
  const alert = useAlert();
  const { id } = useParams();

  const [banner, setBanner] = useState("");
  const [cover, setCover] = useState("");
  const [loading, setLoading] = useState(false);
  const [auctionSet, setAuction] = useState([]);

  const [values, setValues] = useState({
    auction_name: "",
    auction_descriptions: "",
    catalog_download: "",
    catalog_url: "",
    date_start: "",
    date_end: "",
    auctionType: "",
    isLive: "",
    isShow: "",
    showHp: "",
    auction_status: "",
    bp: "",
  });

  const [open, setOpen] = useState(false);
  const [openSetup, setUpstatus] = useState(false);
  const [dataData, setData] = useState([]);


  // =====================================================
  // GET DATA
  // =====================================================

  const GetData = async () => {
    try {
      const results = await GetAuctionByID(id);

      setBanner(results.auction_banner);
      setCover(results.auction_cover);

      setValues({
        id: results.id,
        auction_name: results.auction_name,
        auction_descriptions: results.auction_descriptions,
        catalog_download: results.catalog_download,
        catalog_url: results.catalog_url,
        date_start: results.date_start,
        date_end: results.date_end,
        auctionType: results.auctionType,
        isLive: results.isLive,
        isShow: results.isShow,
        showHp: results.showHp,
        auction_status: results.auction_status,
        bp: results.bp,
      });

      const sets = await GetAuctionSetByID(id);

      setAuction(
        sets === "no record found" ? [] : sets
      );

    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    GetData();
  }, [id]);


  // =====================================================
  // CHANGE
  // =====================================================

  const handleChange = (event) => {
    const { name, value } = event.target;

    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  // =====================================================
  // UPDATE
  // =====================================================

  const handeleUserUpdate = async (e) => {
    e.preventDefault();

    setLoading(true);

    const ArrayData = {
      auction_name: values.auction_name,
      auction_descriptions: values.auction_descriptions,
      catalog_download: values.catalog_download,
      catalog_url: values.catalog_url,
      date_start: values.date_start,
      date_end: values.date_end,
      auctionType: values.auctionType,
      isLive: values.isLive,
      isShow: values.isShow,
      showHp: values.showHp,
      auction_status: values.auction_status,
      bp: parseFloat(values.bp),
    };

    try {
      const result = await AuctionUpdateSend(
        values.id,
        ArrayData
      );

      alert.success(result);
    } catch (error) {
      console.error(error);
      alert.error("Unable to update auction.");
    } finally {
      setLoading(false);
    }
  };


  // =====================================================
  // SET ACTIONS
  // =====================================================

  const handleClickUpdate = (data) => {
    setData(data);
    setOpen(true);
  };

  const handleClickCreate = () => {
    setUpstatus(true);
  };

  const handleClose = () => {
    setOpen(false);
    setUpstatus(false);
    setLoading(false);
  };

  const loadingData = (status) => {
    setLoading(status);
    return GetData();
  };


  // =====================================================
  // RENDER
  // =====================================================

  return (
    <Box className={classes.root}>

      {/* ==============================
          UPDATE SET DIALOG
      ============================== */}

      <UpdateAuctionDialog
        status={open}
        loadingData={loadingData}
        onClose={handleClose}
        dataData={dataData}
      />

      <AuctionSetupCreate
        statusSetup={openSetup}
        onCloseSetup={handleClose}
        dataData={id}
      />


      {/* ==============================
          AUCTION DETAILS
      ============================== */}

      <Card className={classes.card}>

        

      

        <CardContent className={classes.cardContent}>

          {/* ==============================
              BASIC INFORMATION
          ============================== */}

          <Box className={classes.section}>

            <Typography className={classes.sectionTitle}>
              Basic Information
            </Typography>

            <Typography className={classes.sectionDescription}>
              Enter the main information displayed for the auction.
            </Typography>

            <Grid container spacing={3}>

              <Grid item xs={12} md={6}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  label="Auction Name"
                  name="auction_name"
                  value={values.auction_name || ""}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  label="Description"
                  name="auction_descriptions"
                  value={values.auction_descriptions || ""}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  label="Catalog URL"
                  name="catalog_url"
                  value={values.catalog_url || ""}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  label="Catalog Download"
                  name="catalog_download"
                  value={values.catalog_download || ""}
                  onChange={handleChange}
                />
              </Grid>

            </Grid>

          </Box>


          <Divider className={classes.divider} />


          {/* ==============================
              AUCTION SCHEDULE
          ============================== */}

          <Box className={classes.section}>

            <Typography className={classes.sectionTitle}>
              Auction Schedule
            </Typography>

            <Typography className={classes.sectionDescription}>
              Define when the auction starts and ends.
            </Typography>

            <Grid container spacing={3}>

              <Grid item xs={12} md={4}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  type="date"
                  label="Start Date"
                  name="date_start"
                  value={
                    values.date_start
                      ? values.date_start.slice(0, 10)
                      : ""
                  }
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  type="date"
                  label="End Date"
                  name="date_end"
                  value={
                    values.date_end
                      ? values.date_end.slice(0, 10)
                      : ""
                  }
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  select
                  label="Auction Type"
                  name="auctionType"
                  value={values.auctionType || ""}
                  onChange={handleChange}
                >
                  {AuctionType.map((item) => (
                    <MenuItem
                      key={item.id}
                      value={item.value}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

            </Grid>

          </Box>


          <Divider className={classes.divider} />


          {/* ==============================
              AUCTION SETTINGS
          ============================== */}

          <Box className={classes.section}>

            <Typography className={classes.sectionTitle}>
              Auction Settings
            </Typography>

            <Typography className={classes.sectionDescription}>
              Configure visibility, live status and pricing settings.
            </Typography>

            <Grid container spacing={3}>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  select
                  label="Live Auction"
                  name="isLive"
                  value={values.isLive ?? ""}
                  onChange={handleChange}
                >
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  select
                  label="Show Auction"
                  name="isShow"
                  value={values.isShow ?? ""}
                  onChange={handleChange}
                >
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  select
                  label="Show Hammer Price"
                  name="showHp"
                  value={values.showHp ?? ""}
                  onChange={handleChange}
                >
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  select
                  label="Auction Status"
                  name="auction_status"
                  value={values.auction_status ?? ""}
                  onChange={handleChange}
                >
                  <MenuItem value={0}>
                    Previous Auction
                  </MenuItem>

                  <MenuItem value={1}>
                    Upcoming Auction
                  </MenuItem>

                  <MenuItem value={2}>
                    Ongoing Auction
                  </MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  className={classes.field}
                  variant="outlined"
                  type="number"
                  label="Buyer Premium"
                  name="bp"
                  value={values.bp ?? ""}
                  onChange={handleChange}
                  inputProps={{
                    step: "0.01",
                  }}
                />
              </Grid>

            </Grid>

          </Box>


          {/* ==============================
              UPDATE
          ============================== */}

          <Box className={classes.actionBar}>

            <Button
              variant="contained"
              color="primary"
              className={classes.updateButton}
              onClick={handeleUserUpdate}
              disabled={loading}
            >
              Update Auction
            </Button>

          </Box>

        </CardContent>

      </Card>


      {/* ==============================
          MEDIA
      ============================== */}

      <Box mt={3}>

        <Card className={classes.card}>

          <CardHeader
            className={classes.cardHeader}
            title="Auction Media"
            subheader="Manage the banner and cover image."
          />

          <Divider />

          <CardContent className={classes.cardContent}>

            <Box className={classes.mediaWrapper}>

              <UploadImage
                IDMAGE={id}
                Banner={banner}
                Cover={cover}
              />

            </Box>

          </CardContent>

        </Card>

      </Box>


      {/* ==============================
          AUCTION SETS
      ============================== */}

      <Box mt={3}>

        <Card className={classes.card}>

          <CardHeader
            className={classes.cardHeader}
            title="Auction Sets"
            subheader="Create and manage the sets included in this auction."
          />

          <Divider />

          <CardContent className={classes.cardContent}>

            <Box className={classes.setsToolbar}>

              <Typography className={classes.setsCount}>
                {auctionSet.length === 0
                  ? "No auction sets"
                  : `${auctionSet.length} auction set${
                      auctionSet.length > 1
                        ? "s"
                        : ""
                    }`}
              </Typography>

              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                className={classes.addButton}
                onClick={() => handleClickCreate(id)}
              >
                Add Auction Set
              </Button>

            </Box>


            <TableContainer className={classes.tableContainer}>

              <Table className={classes.table}>

                <TableHead>

                  <TableRow className={classes.tableHead}>

                    <TableCell className={classes.tableHeadCell}>
                      Set Name
                    </TableCell>

                    <TableCell className={classes.tableHeadCell}>
                      Start
                    </TableCell>

                    <TableCell className={classes.tableHeadCell}>
                      End
                    </TableCell>

                    <TableCell
                      align="center"
                      className={classes.tableHeadCell}
                    >
                      Actions
                    </TableCell>

                  </TableRow>

                </TableHead>


                <TableBody>

                  {auctionSet.length > 0 ? (

                    auctionSet.map((row) => (

                      <TableRow hover key={row.id}>

                        <TableCell className={classes.tableCell}>
                          <Typography className={classes.setName}>
                            {row.set_name}
                          </Typography>
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <div className={classes.dateText}>
                            {row.date_start?.slice(0, 10)}
                            <br />
                            <span className={classes.timeText}>
                              {row.time_start}
                            </span>
                          </div>
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <div className={classes.dateText}>
                            {row.date_end?.slice(0, 10)}
                            <br />
                            <span className={classes.timeText}>
                              {row.time_end}
                            </span>
                          </div>
                        </TableCell>

                        <TableCell
                          align="center"
                          className={classes.tableCell}
                        >

                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            startIcon={<EditRoundedIcon />}
                            className={classes.actionButton}
                            onClick={() =>
                              handleClickUpdate(row)
                            }
                          >
                            Edit
                          </Button>

                          <Button
                            size="small"
                            variant="outlined"
                            startIcon={<VisibilityIcon />}
                            className={classes.actionButton}
                            href={`/app/auctions/view/lots/${values.auction_name}/${row.auction_id}/${row.id}`}
                          >
                            View
                          </Button>

                        </TableCell>

                      </TableRow>

                    ))

                  ) : (

                    <TableRow>

                      <TableCell
                        colSpan={4}
                        className={classes.tableCell}
                      >

                        <Box className={classes.emptyState}>
                          <Typography variant="body2">
                            No auction sets found.
                          </Typography>
                        </Box>

                      </TableCell>

                    </TableRow>

                  )}

                </TableBody>

              </Table>

            </TableContainer>

          </CardContent>

        </Card>

      </Box>


      {/* ==============================
          LOADING
      ============================== */}

      <Backdrop
        className={classes.backdrop}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

    </Box>
  );
}